import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import { SearchFormType } from '../types/NewDrawers.types'

export const defaultValues: SearchFormType = {
  equipmentId: '',
  phoneNumber: '',
}

export const validateEquipmentId = (value: string) => {
  if (!value?.length) return true // Пустое значение пропускаем (ошибку покажет общая проверка)

  if (value.length !== 14) return false

  const number = +value.slice(0, 2)
  const summ = value
    .slice(2, 14)
    .split('')
    .reduce((acc, el) => +acc + +el, 0)

  return summ === number
}

export const searchFormSchema = z
  .object({
    equipmentId: z.string().refine((val) => !val || validateEquipmentId(val), {
      path: ['root'], // Указываем путь для ошибки
    }),
    phoneNumber: z
      .string()
      .transform((val) => val.replace(/\D/g, ''))
      .refine((val) => !val || val.length === 11, {
        path: ['root'], // Указываем путь для ошибки
      }),
  })
  .refine((data) => data.equipmentId || data.phoneNumber, {
    path: ['root'],
  })

export const resolver = zodResolver(searchFormSchema)
